import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import {
  BodyTextMedium, HeadlineTextMedium,
} from 'Packages/FacetDesign/Components';
import useBoneBackgroundColor from 'Hooks/useBoneBackgroundColor';
import Layout from './Layout';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => HeadlineTextMedium,
    _customProps: {
      color: 'textSecondary',
    },
  }, overrideReadOnly)
  .nameOverride('subtitle', {
    _component: () => BodyTextMedium,
    _customProps: {},
  }, overrideReadOnly)
  .done();

const ManagedAccountModelUpdateRequestAggregatePageTemplate = ({ resource }) => {
  useBoneBackgroundColor();

  return (
    <MetaResourceRenderer
      layout={Layout}
      resource={resource}
      metaOverrideSet={metaOverrideSet}
    />
  );
};

ManagedAccountModelUpdateRequestAggregatePageTemplate.defaultProps = {};

ManagedAccountModelUpdateRequestAggregatePageTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default ManagedAccountModelUpdateRequestAggregatePageTemplate;
